import React from "react";
import { Select, Tag, Typography } from "antd";

const { Text } = Typography;

export default function ClothingSelectors({ product, size, color, onSizeChange, onColorChange }) {
  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ marginBottom: 12 }}>
        <Text strong>Selecciona la talla:</Text>
        <Select
          value={size}
          placeholder="Selecciona una talla"
          size="large"
          style={{ width: "100%", marginTop: 8 }}
          onChange={onSizeChange}
          options={(product?.sizes || []).map((s) => ({ value: s, label: s }))}
        />
      </div>

      <div style={{ marginBottom: 12 }}>
        <Text strong>Selecciona el color:</Text>
        <Select
          value={color}
          placeholder="Selecciona un color"
          size="large"
          style={{ width: "100%", marginTop: 8 }}
          onChange={onColorChange}
          options={(product?.colors || []).map((c) => ({ value: c, label: c }))}
        />
      </div>

      <div>
        <Text strong>Disponible para: </Text>
        <Tag color="purple">{product?.gender || "Unisex"}</Tag>
      </div>
    </div>
  );
}
